"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Fade = _interopRequireDefault(require("../Fade"));
var _header = _interopRequireDefault(require("./header"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _createWithBSPrefix = _interopRequireDefault(require("../createWithBSPrefix"));
var _excluded = ["children", "isOpen", "className", "closable"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Modal/index.js";
var propTypes = {
  size: _propTypes["default"].oneOf(["sm", "lg", "xl"])
};
function noop() {}
var defaultProps = {
  isOpen: false,
  onClosed: noop
};
function Modal(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    className = _ref.className,
    closable = _ref.closable,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState(isOpen),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(isOpen),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    isFade = _React$useState4[0],
    setFade = _React$useState4[1];
  _react["default"].useEffect(function () {
    isOpen && setOpen(isOpen);
    setFade(isOpen);
    isOpen && document.body.classList.add('modal-open');
  }, [isOpen]);
  function renderModal() {
    var dialogBaseClass = "modal-dialog modal-dialog-centered";
    var size = "modal-" + props.size;
    var classes = (0, _classNames["default"])(dialogBaseClass, size);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-100 h-100 position-absolute",
      onClick: onCLick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 17
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "modal-content",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 21
      }
    }, children)));
  }
  function onClosed(node) {
    props.onClosed(node);
    setOpen(isOpen);
    document.body.classList.remove('modal-open');
  }
  var onCLick = function onCLick() {
    if (closable) setOpen(false);
  };
  if (!open) return null;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
    "in": isFade,
    className: "modal-backdrop",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
    "in": isFade,
    className: (0, _classNames["default"])("modal d-block", className),
    onExited: onClosed,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 13
    }
  }, renderModal()));
}
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.Header = _header["default"];
Modal.Body = (0, _createWithBSPrefix["default"])("modal-body");
Modal.Footer = (0, _createWithBSPrefix["default"])("modal-footer");
var _default = exports["default"] = Modal;